import { Button, Grid } from '@material-ui/core';
import React from 'react';
import CustomAppBar from '../../commons/AppBar';
import SpecificComponent from '../../commons/SpecificComponent';
import LocalStorage from '../../providers/LocalStorage';
import Utils from '../../providers/Utils';
import WsC from './providers/WsC'
import { ReactComponent as FileInvoiceSolid } from './Icoane Font Awesome/file-invoice-solid.svg';
import { ReactComponent as TrashAltSolid } from './Icoane Font Awesome/trash-alt-solid.svg'
import AlertNew from '../../commons/dialogs/AlertNew';

export default class ChestionareEvaluari extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            chestionare: [],
            chestionarSelectat:{},
            openDeleteChestionar:false,
            alertView:false
        }
    }

    componentDidMount() {
        this.access()
        this.getChestionare()
    }

    u = new Utils()
    ws = new WsC()
    ls = new LocalStorage().GetUserData()

    access = async () => {



        console.log('this.ls.InfoUser.IsAdmin :>> ', this.ls.InfoUser.IsAdmin);

        if (this.ls.InfoUser.IsAdmin !== 1) {


            this.setState({ alertView: this.ls.InfoUser.EsteSef === 1 ? false : true })
        }


    }


    getChestionare = async () => {


        console.log('this.ls. :>> ', this.ls.InfoUser.Database);

        let chestionare = await this.ws.customSelect(`select u.nume as nume_utilizator,  c.* , (select count(*) from chestionare_intrebari where id_chestionar = c.id and isnull(id_parent,0) = 0 and isnull(inactiv,0) != 1) as nr_intrebari 
                                                    from chestionare c left join [${this.ls.InfoUser.Database}].[dbo].[useri] u on c.creat_de = u.id  where c.baza_date = @p1 and isnull(c.sters,0) != 1`,
            { p1: this.ls.InfoUser.Database })


        console.log('chestionare :>> ', chestionare);

        if (chestionare.Succes) {
            this.setState({ chestionare: chestionare.Content })
        }


    }

    dataAzi = () => {


        let dataAzi = this.u.defaultData()

        if (this.dictionary.date === 'en') {
            return this.u.dataPrescurtataEng(dataAzi)
        } else {
            return this.u.dataPrescurtataRomana(dataAzi)
        }
    }


    returnButton = () => {
        let rez = []




        rez.push(<div key={1}>
            <Button style={{ display: this.props.displayInsert === 1 ? 'none' : 'inline-flex', padding: 10, backgroundColor: 'rgb(24 166 59)', color: 'white', fontWeight: 500 }} onClick={this.addChestionar}  >
                <i className='material-icons pm-round-button-text'>add</i>
                                   Chestionar Nou
                                </Button>
        </div>)




        return rez
    }

    buildAppBarButtons = () => {
        let rez = []

        rez.push(<div>
            <span style={{ color: 'black', marginRight: 10 }}>Astazi:{this.dataAzi()} </span>
        </div>)

        return rez
    }

    addChestionar = () => {
        this.props.history.push(`/chestionarnou/${this.props.match.params.idsesiune}/${this.props.match.params.tip}`)
    }

    goToChestionar = (c) =>{
        this.props.history.push(`/chestionardetalii/${c.id}/${this.props.match.params.idsesiune}/${this.props.match.params.tip}`)
    }

    openStergeChestionar = (c) =>{
        this.setState({openDeleteChestionar:true,
                        chestionarSelectat:c})
    }


    stergeChestionar = async () =>{

        let stergeC = await this.ws.update('chestionare', {sters:1}, {id:this.state.chestionarSelectat.id})

        if(stergeC.Succes){

            this.setState({openDeleteChestionar:false},()=>{

                this.getChestionare()
            })

        }
    }

    render() {
        return (
            <div>
                <CustomAppBar history={this.props.history} title={this.returnButton()} appBarButtons={this.buildAppBarButtons()} />

                <AlertNew
                    open={this.state.alertView}
                    dialogClose={() => { this.setState({ alertView: false }) }}
                    title={this.dictionary.proiecte.alertView}
                    mesaj={this.dictionary.proiecte.alertViewMessage}
                    noButtonDisplay={1}
                    yesFunction={() => { this.props.history.replace('/') }}
                />

                <AlertNew
                    open={this.state.openDeleteChestionar}
                    dialogClose={() => { this.setState({ openDeleteChestionar: false }) }}
                    title={'Doresti sa stergi chestionarul selectat ?'}
                    mesaj={'Atentie ! Chestionarul odata sters nu mai poate fi recuperat. '}
                    yesFunction={this.stergeChestionar}
                    deleteP={true}
                />
                <Grid style={{ maxWidth: 1000, margin: 'auto' }} container>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <h1 style={{ margin: '80px 0 40px 0' }} className='pm-title-big'>Chestionare Evaluari </h1>
                    </Grid>


                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40 }}>

                            {this.state.chestionare.length === 0 &&
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <h5 style={{ textAlign: 'left', fontWeight: 400 }}>Nu exista nici un chestionar in sistem. Creeaza un chestionar nou apasand butonul de mai jos. Inspira-te sau folseste in intregime template-urile gata create de catre expertii nostri.</h5>
                                </Grid>
                            }


                            {this.state.chestionare.length > 0 && this.state.chestionare.map((c, idx) => {
                                return (
                                    <Grid style={{ textAlign: 'left', marginBottom: 20, background: 'rgb(249,249,249)', padding: 10 }} key={idx} container>



                                        <Grid style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} item xs={1} sm={1} md={1} lg={1} xl={1}>
                                            <FileInvoiceSolid onClick={() => { this.setState({ openSettings: this.state.openSettings ? false : true }) }} className='iconSvg' style={{ verticalAlign: 'bottom', cursor: 'pointer' }} />


                                        </Grid>


                                        <Grid item xs={11} sm={11} md={11} lg={11} xl={11}>
                                            <Grid container>

                                                <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{c.titlu}</span>
                                                    <span className='textSecondary' style={{ marginRight: 20, fontSize: 12, display: 'block', }}>{c.nume_utilizator}</span>

                                                </Grid>
                                                <Grid style={{ textAlign: 'center' }} item xs={2} sm={2} md={2} lg={2} xl={2}>

                                                    {/* <span style={{ marginRight: 20, fontSize: 12, display:'block', lineHeight:2 }}>Valoare:<span style={{fontWeight:600}}>{t.suma_cheltuieli.toFixed(3)}</span></span> */}
                                                    <span className='textSecondary' style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400 }}>Ultima editare</span>
                                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{this.u.ParseDataFromSql(c.creat_la)}</span>


                                                </Grid>

                                                <Grid style={{ textAlign: 'center' }} item xs={4} sm={4} md={4} lg={4} xl={4}>

                                                    {/* <span style={{ marginRight: 20, fontSize: 12, display:'block', lineHeight:2 }}>Valoare:<span style={{fontWeight:600}}>{t.suma_cheltuieli.toFixed(3)}</span></span> */}
                                                    <span className='textSecondary' style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400 }}>Intrebari</span>
                                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{c.nr_intrebari}</span>


                                                </Grid>


                                                <Grid style={{
                                                    justifyContent: 'center',
                                                    display: 'flex',
                                                    alignItems: 'center'}} item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                    <TrashAltSolid className=' iconSvg' onClick={() => { this.openStergeChestionar(c) }} style={{ marginRight: 0, width: 18, height: 18 }} />
                                                <i style={{ marginLeft: 10, fontSize: 18 }} onClick={() => { this.goToChestionar(c) }} className="material-icons iconFontSize ">edit</i>

                                                {/* <i onClick={() => { this.props.intrebare.tip !== 'grupaj' ? this.props.deleteRaspuns(r) : this.deleteRaspuns(r) }} style={{ marginRight: 0, }} className="material-icons iconFontSize textSecondary">delete</i> */}

                                            </Grid>


                                        </Grid>

                                    </Grid>



                                    </Grid>
                                )
                            })}


                            <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Button style={{ padding: 10, backgroundColor: 'rgb(24 166 59)', color: 'white', fontWeight: 500 }} onClick={this.addChestionar}  >
                                <i className='material-icons pm-round-button-text'>add</i>
                                   Chestionar Nou
                                </Button>
                        </Grid>

                    </Grid>




                </Grid>
                </Grid>
            </div >
        );
    }
}